import React, { useState, useEffect, useContext } from "react";
import "./Product_Cart.css";
import {
  Breadcrumb,
  Button,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

import Cart from "./Cart/Cart";
import { Context } from "../../utils/context";

const Product_Cart = () => {
  const {
    signin,
    setMembershipDiscount,
    membershipDiscount,
    setDiscount,
    discount,
  } = useContext(Context);

  const [amount, setAmount] = useState(0);
  const [coupon, setCoupon] = useState("");

  return (
    <>
      <div className="Product_Cart">
        <div className="container">
          <div className="heading_holder">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={"/"}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                <Link to={"/product-cart"}>Cart</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Cart
            type={"cart"}
            amount={amount}
            setAmount={setAmount}
            discount={discount}
            setDiscount={setDiscount}
            coupon={coupon}
            setCoupon={setCoupon}
            membershipDiscount={membershipDiscount}
            setMembershipDiscount={setMembershipDiscount}
          />
        </div>
      </div>
    </>
  );
};

export default Product_Cart;
